import { NgModule } from '@angular/core';
import { ApiHealthTrackerBodyBatteryService } from './body-battery/body-battery.service';
import { ApiHealthTrackerService } from './health-tracker.service';
import { ApiHealthTrackerSleepService } from './sleep/sleep.service';
import { ApiHealthTrackerStressService } from './stress/stress.service';

/**
 * Health Tracker API Module.
 * Modularizes all health tracker related services and providers.
 *
 * @exports
 * @class HealthTrackerModule
 */
@NgModule({
  providers: [
    ApiHealthTrackerService,
    ApiHealthTrackerBodyBatteryService,
    ApiHealthTrackerSleepService,
    ApiHealthTrackerStressService
  ]
})
export class ApiHealthTrackerModule {}
